import { AgGridReact } from "ag-grid-react";
import {
  biletColumns,
  defaultColDef,
  getRowId,
  toolPanelStyles,
} from "../../utils/gridHelper";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  deleteBilet,
  getBilet,
  getBiletQuestion,
} from "../../utils/API/biletMethods";
import { Button } from "@mui/material";
import GridToolBar from "../GridToolBar";
import { useStore } from "../../hooks/store";
import BiletForm from "../Form/BiletForm/BiletForm";

import AddIcon from "@mui/icons-material/Add";

export function BiletGrid() {
  const store = useStore();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [biletData, setBiletData] = useState(undefined);

  const fetchBiletData = () => {
    getBilet().then(({ data }) => {
      setGridData(data);
    });
  };

  const handleAddOpener = () => {
    store.setForm(<BiletForm />, fetchBiletData);
  };

  const handleRedactOpener = () => {
    const { id } = biletData;
    getBiletQuestion(id).then(({ data }) => {
      const newBilet = {
        ...biletData,
        questions: data,
      };

      store.setForm(<BiletForm />, fetchBiletData, newBilet);
    });
  };

  const handleDelete = async () => {
    const { id } = biletData;
    await deleteBilet(id);
    await fetchBiletData();
    return;
  };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchBiletData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data && setBiletData(e.data);
  };

  return (
    <div style={{ maxWidth: "100%", height: "100%" }}>
      <GridToolBar
        filter={true}
        onAdd={handleAddOpener}
        onRefresh={fetchBiletData}
        onDelete={handleDelete}
        onUpdate={handleRedactOpener}
        filterValue={quickFilterText}
        filterOnChange={setQuickFilterText}
        dataToAction={biletData}
      />
      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...biletColumns]}
      />
    </div>
  );
}
